import { FinanceScreen } from "@/modules/finance";
import { FinanceFilters } from "@/modules/finance/components/filters/FinanceFilters";
import { useMemo } from "react";
import { FinanceFilterProvider } from "@/modules/finance/helper/context/finance-filter.context";
import { Wrapper } from "@/components/layout";

export const FinancePage = () => {
  const filters = useMemo(() => <FinanceFilters />, []);

  return (
    <FinanceFilterProvider>
      <Wrapper title="Finance Page" rightFilters={filters} mainClassName="flex flex-1 flex-col overflow-hidden">
        <div className="flex flex-col flex-1 p-5 mx-auto bg-white shadow-xs rounded-lg w-full overflow-hidden">
          <FinanceScreen />
        </div>
      </Wrapper>
    </FinanceFilterProvider>
  );
};
